import { render, staticRenderFns } from "./CheckoutOffersCardOld.vue?vue&type=template&id=fc942664&scoped=true&lang=pug&"
import script from "./CheckoutOffersCardOld.vue?vue&type=script&lang=js&"
export * from "./CheckoutOffersCardOld.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutOffersCardOld.vue?vue&type=style&index=0&id=fc942664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc942664",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow,VSkeletonLoader,VSpacer})
